export default [
  { path: '/emitidas/emitidas-como-proveedor', component: () => import('@/views/issued/AsProvider.vue') },
  { path: '/emitidas/emitidas-como-proveedor/:status', component: () => import('@/views/issued/AsProvider.vue') },
  { path: '/emitidas/emitidas-como-pagador', component: () => import('@/views/issued/AsPayer.vue') },
  { path: '/emitidas/emitidas-como-pagador/:status', component: () => import('@/views/issued/AsPayer.vue') },
  // { path: '/emitidas/financiacion', component: () => import('@/views/issued/Financeables.vue') },
  { path: '/emitidas/factoring', component: () => import('@/views/issued/Financeables.vue') },
  { path: '/emitidas/facturas-terceros-por-gastos-suplidos', component: () => import('@/views/issued/ThirdPartyInvoices.vue') }
]
